import React, {Component} from 'react'
import SocialIcon from "./SocialIcon";


class Footer extends Component {
    render() {
        return (
            <footer>
                <div className="footer">
                    <div className="container">
                        <div className="row align-items-center text-md-center">
                            <div className="wrap-icon-footer">
                                <SocialIcon/>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;